// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1jMFi","buttons":"SendReceipts_buttons__3Aqzj","email":"SendReceipts_email__2YODy","bookApptTitle":"SendReceipts_bookApptTitle__2X16G"};